import { useApp } from "@/store/AppStore";

interface BrandLogoProps {
  compact?: boolean;
}

// Identidad de marca: muestra el logo cargado por el admin (data URL) o,
// si no hay ninguno, el monograma ATT por defecto.
const BrandLogo = ({ compact = false }: BrandLogoProps) => {
  const { data } = useApp();
  const logo = data.settings.logoUrl;

  return (
    <div className="flex items-center gap-3">
      <div className="relative w-11 h-11 rounded-lg overflow-hidden bg-gradient-to-br from-primary-500 to-primary-800 border border-accent-500/40 flex items-center justify-center shrink-0">
        {logo ? (
          <img
            src={logo}
            alt="Logo Amway Tienda Digital Domicilios"
            title="Amway Tienda Digital Domicilios"
            className="w-full h-full object-contain"
          />
        ) : (
          <>
            <span className="font-heading font-extrabold text-accent-300 text-lg tracking-tight">
              ATT
            </span>
            <span className="absolute -bottom-1 -right-1 w-3.5 h-3.5 rounded-full bg-accent-500 flex items-center justify-center">
              <i className="ri-checkbox-blank-circle-fill text-[6px] text-background-50" />
            </span>
          </>
        )}
      </div>
      {!compact && (
        <div className="leading-tight">
          <p className="font-heading font-bold text-foreground-950 text-[15px] tracking-tight">
            Amway Tienda Digital
          </p>
          <p className="text-[11px] text-accent-300 font-medium tracking-wide uppercase">
            Domicilios · ATDD
          </p>
        </div>
      )}
    </div>
  );
};

export default BrandLogo;